import React, { useState, useEffect, useRef } from "react";
import growthicon from "../../../assets/img/GG210.png";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import axios from "axios";
import * as yup from "yup";
import { Formik } from "formik";
import Navigation from "../../../common/Navigation";
import { API_AUTH } from "../../../utils/config";
//  signin screen component
const SignInScreen = () => {
  let history = useHistory();
  const [err, seterr] = useState("");
  const [valid, setvalid] = useState(false);
  const textInput = useRef(null);
  
  // validation schema
  const signINValidationSchema = yup.object().shape({
    email: yup
      .string()
      .email("Please enter valid email")
      .required("Email address is required"),
  });

  useEffect(() => {
    checkingCurrentUser();
    textInput.current.focus();
  });
   // checking current candidate function

  const checkingCurrentUser = () => {
    axios
      .get(`${API_AUTH}/v1/api/auth/isLoggedIn`, { withCredentials: true })
      .then((response) => {
        if (response.data) {
         history.push({
            pathname: "/dashboard",
          });   
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // onSubmit function for navigating to sign in password component
  const onSubmit = async (email) => {
    setvalid(false);

    let body = {
      email,
      ipAddress: "150.82.224.211",
      browser: "",
      OS: "",
      isTablet: false,
      isPhone: false,
      isBot: false,
      location: "",
      isSuspicious: false,
    };

    console.log(body);
    await axios
      .post(`${API_AUTH}/v1/api/auth/verify/login`, body, {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response);
        if (response.data.ok) {
          history.push({
            pathname: "/signin_password",
            state: email,
          });
        } else if (!response.data.ok) {
          setvalid(true);
          seterr("Email not found. Please create account for SignIn");
        }
      })
      .catch((err) => {
        console.log(err, "errors");
      });
  };
  return (
    <>
      <Navigation show="true" />
      <Formik
        validationSchema={signINValidationSchema}
        initialValues={{ email: "" }}
        onSubmit={(values) => onSubmit(values.email)}
      >
        {({ handleChange, handleSubmit, values, errors, touched, isValid }) => (
          <>
            <div className="sign-container">
              <div className="child-signcontainer">
                <div className="child-firstcontainer">
                  <img
                    style={{ marginRight: "20px", marginTop: "60px" }}
                    src={growthicon}
                    height="60"
                    width="170"
                    alt="PION global"
                    id="logo"
                  ></img>
                </div>

                <div className="child-secondcontainer">
                  <span
                    style={{
                      fontWeight: 500,
                      fontSize: "25px",
                      marginTop: "10px",
                    }}
                  >
                    Sign in
                  </span>

                  <div className="sign-form">
                    <input
                      type="text"
                      name="email"
                      placeholder="Email"
                      ref={textInput}
                      onKeyPress={(e) => {
                        console.log(e);
                        if (e.code === "Enter") {
                          handleSubmit();
                        }
                      }}
                      // value={email}
                      onChange={(email) => {
                        handleChange(email);
                        setvalid(false);
                      }}
                      // onChange={setvalid(false)}
                      value={values.email}
                      autoComplete="off"
                      required
                    ></input>

                    {errors.email && touched.email && (
                      <span style={{ fontSize: 15, color: "red" }}>
                        {errors.email}
                      </span>
                    )}

                    {err && valid && (
                      <span style={{ fontSize: 15, color: "red" }}>{err}</span>
                    )}
                  </div>
                  <input className="x-display" type="submit" />

                  <div className="account-form">
                    <span style={{ fontSize: "14px", fontWeight: 400 }}>
                      No account?
                    </span>
                    <span style={{ fontSize: "14px", marginLeft: "8px" }}>
                      <Link style={{ color: "#005500" }} to="/signup">
                        Create One!
                      </Link>{" "}
                    </span>
                  </div>

                
                </div>
                <div className="log-button">
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      handleSubmit();
                    }}
                    style={{
                      background: "#005500",
                    
                      marginLeft: "350px",
                    }}
                  >
                    Next
                  </Button>
                </div>
              </div>
            </div>
          </>
        )}
      </Formik>
    </>
  );
};

export default SignInScreen;
